import React, { useEffect, useRef } from "react";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";

const DateRangePicker = ({ onDateChange, startDate, endDate }) => {
  const pickerRef = useRef();

  useEffect(() => {
    const $picker = $(pickerRef.current);

    // Remove previous instance
    if ($picker.data("daterangepicker")) {
      $picker.data("daterangepicker").remove();
    }

    // Initialize picker with either passed dates or current month
    const start = startDate ? moment(startDate) : moment().startOf("month");
    const end = endDate ? moment(endDate) : moment().endOf("month");

    const cb = (start, end) => {
      if (onDateChange) {
        onDateChange(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
      }
      $picker
        .find("span")
        .html(
          `${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`
        );
    };

    $picker.daterangepicker(
      {
        startDate: start,
        endDate: end,
        autoUpdateInput: false,
        showDropdowns: true,
        opens: "right",
        linkedCalendars: false, // 🔹 allows selecting different dates properly
        alwaysShowCalendars: true, // optional, keeps both calendars open
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
          "Last 1 Year": [
            moment().subtract(1, "year").startOf("day"),
            moment(),
          ],
        },
      },
      cb
    );

    // Update UI immediately
    $picker
      .find("span")
      .html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);

    $picker.on("mousedown", (e) => e.stopPropagation());
  }, [onDateChange, startDate, endDate]); // <-- Re-initialize whenever dates change

  return (
    <div
      ref={pickerRef}
      style={{
        background: "#fff",
        cursor: "pointer",
        padding: "5px 10px",
        border: "1px solid #ccc",
        width: "100%",
        maxWidth: "300px",
        borderRadius: "4px",
      }}
    >
      <i className="fa fa-calendar" /> &nbsp;
      <span></span> <i className="fa fa-caret-down" />
    </div>
  );
};

export default DateRangePicker;
